import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export default function DoshaBarChart({ vikritiresultData }) {

    const vata = vikritiresultData?.vata ?? 0;
    const pitta = vikritiresultData?.pitta ?? 0;
    const kapha = vikritiresultData?.kapha ?? 0;

    const data = [
        { name: 'Vata', value: vata },
        { name: 'Pitta', value: pitta },
        { name: 'Kapha', value: kapha },
    ];

    const getColor = (index, value) => ({
        positive: ['#BDC5CC', '#CDB9AB', '#5BC35B'][index],
        negative: ['rgba(189,197,204,0.45)', 'rgba(205,185,171,0.45)', 'rgba(91,195,91,0.45)'][index],
    }[value < 0 ? 'negative' : 'positive']);

    const chartData = {
        labels: data.map(d => d.name),
        datasets: [
            {
                label: 'Dosha Score',
                data: data.map(d => d.value),
                borderRadius: (ctx) => {
                    // Round top for positive bars, bottom for negative
                    const val = data[ctx.dataIndex]?.value ?? 0;
                    return val >= 0
                        ? { topLeft: 8, topRight: 8, bottomLeft: 0, bottomRight: 0 }
                        : { topLeft: 0, topRight: 0, bottomLeft: 8, bottomRight: 8 };
                },
                backgroundColor: (context) => {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;
                    if (!chartArea) return null;
                    const val = data[context.dataIndex]?.value ?? 0;
                    const color = getColor(context.dataIndex, val);
                    const g = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                    if (val >= 0) {
                        g.addColorStop(0, color);
                        g.addColorStop(1, color + '55');
                    } else {
                        // Negative: gradient goes from transparent to color (inverted feel)
                        g.addColorStop(0, color);
                        g.addColorStop(1, color);
                    }
                    return g;
                },
                borderWidth: 0,
            }
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            datalabels: { display: false },
            tooltip: {
                enabled: true,
                backgroundColor: 'rgba(59, 54, 42, 0.92)',
                titleFont: { family: "'Poppins', sans-serif", size: 11 },
                bodyFont: { family: "'Poppins', sans-serif", size: 12, weight: '600' },
                padding: 10,
                cornerRadius: 8,
                callbacks: {
                    title: () => '',
                    label: function (tooltipItem) {
                        const val = tooltipItem.raw;
                        const name = tooltipItem.label;
                        const status = val > 0 ? '↑ Increased' : val < 0 ? '↓ Decreased' : '→ Neutral';
                        return ` ${name}: ${Math.abs(val)}  ${status}`;
                    }
                }
            }
        },
        scales: {
            y: {
                // Allow negative bars to render below X-axis
                beginAtZero: false,
                display: false,
                grid: { display: false, drawBorder: false },
                ticks: { display: false },
            },
            x: {
                grid: { display: false },
                ticks: {
                    font: { family: "'Poppins', sans-serif", size: 12 },
                    color: '#3B362A',
                }
            }
        }
    };

    return <Bar data={chartData} options={options} />;
}
